import { ParsedUrlQuery } from 'querystring'

/**
 * Replaces `{token}` placeholders in a CMS internalLink path with the matching
 * value from the current route/query, so a single Sanity link can adapt to the
 * page it sits on.
 *
 * e.g. `/get-started?tier={tier}&frequency={frequency}` on
 * `/packages/kakano?frequency=monthly` → `/get-started?tier=kakano&frequency=monthly`
 * (`tier` comes from the `[tier]` route param, `frequency` from the query string).
 *
 * Unknown/absent tokens resolve to an empty string — the target page is expected
 * to apply its own default (e.g. /get-started defaults an empty frequency to
 * monthly). Paths without any `{token}` are returned unchanged.
 */
export const interpolatePathTokens = (
  path: string,
  query: ParsedUrlQuery
): string =>
  path.replace(/\{(\w+)\}/g, (_match, key: string) => {
    const value = query[key]
    return (Array.isArray(value) ? value[0] : value) ?? ''
  })
